// extracted by mini-css-extract-plugin
module.exports = {"button":"Button-module--button--6y6Zv","showAll":"Button-module--show-all--3OPcM","dots":"Button-module--dots--9uIus"};